import { useCallback, useState } from 'react'
import { VehicleInProgressDialog } from '@components/vin/vehicle-in-progress'
import { vehicleInProgressFrom } from '../api/vehicleInProgress'

/**
 * CAR-4021 — the notice shared by New Quote and New Work Order when the create is refused because the same
 * job (body shop, RO, VIN) is still open. There is no override.
 *
 *   const { handleCreateError, renderVehicleInProgress } = useVehicleInProgress('quote')
 *   } catch (err) { if (handleCreateError(err)) return; … }
 *   {renderVehicleInProgress()}
 *
 * handleCreateError is true when it opened the notice. Any other error is left to the caller.
 */
export const useVehicleInProgress = (kind) => {
  const [refusal, setRefusal] = useState(null)

  const handleCreateError = useCallback((error) => {
    const found = vehicleInProgressFrom(error)
    if (!found) return false
    setRefusal(found)
    return true
  }, [])

  const renderVehicleInProgress = () => <VehicleInProgressDialog kind={kind} refusal={refusal} onClose={() => setRefusal(null)} />

  return { handleCreateError, renderVehicleInProgress }
}
